<template>
  <div class="synthese__container">
    <SyntheseSection
      title="L'employeur"
      :items="employerDetails"
    />

    <SyntheseSection
      title="Salarié(e)"
      :items="salariesDetails"
    >
      <template #header>
        <div class="element__header">
          <BasicText
            size="body-m"
            color="secondary-900"
            weight="bold"
          >
            Nom
          </BasicText>
          <BasicText
            size="body-m"
            color="secondary-900"
            weight="bold"
          >
            Date naissance
          </BasicText>
          <BasicText
            size="body-m"
            color="secondary-900"
            weight="bold"
          >
            Nature contrat
          </BasicText>
        </div>
      </template>
      <template #items>
        <div
          v-for="(salarie, index) in salariesDetails"
          :key="index"
          class="element__row"
        >
          <BasicText
            size="body-m"
            color="secondary-900"
            style="height: auto"
          >
            {{ salarie['Nom'] ?? '' }}
          </BasicText>
          <BasicText
            size="body-m"
            color="secondary-900"
            style="height: auto"
          >
            {{ salarie['Date de naissance'] ?? '' }}
          </BasicText>
          <BasicText
            size="body-m"
            color="secondary-900"
            style="height: auto"
          >
            {{ salarie['Nature du contrat'] ?? '' }}
          </BasicText>
        </div>
      </template>
    </SyntheseSection>
    <SyntheseSection
      v-for="(formation, index) in formations"
      :key="index"
      :title="formation.$titreSynthese"
      :items="formation"
    />
    <SyntheseSection
      title="Chiffrage (montants HT)"
      :items="chiffrageDetails"
    />
  </div>
  <FormContainer>
    <template #content>
      <WrapperCheckbox
        id="field_unknown1"
        v-model="attestationSurHonneurModel"
        :alertLabel="meta.attestationSurHonneur?.$messageErreurDirty!"
        :required="meta.attestationCadreInterventionFse?.$status === PropertyStatus.Required"
        label="J’atteste sur l’honneur l’exactitude des données saisies."
        :readonly
        class="col-36"
      />
      <WrapperCheckbox
        id="field_unknown2"
        v-model="acceptationCgModel"
        :alertLabel="meta.acceptationCg?.$messageErreurDirty!"
        :required="meta.attestationCadreInterventionFse?.$status === PropertyStatus.Required"
        :readonly
        class="col-36"
      >
        <BasicText style="flex: 1">
          J'accepte les Conditions Générales (CG) d'Akto et les conditions de prise en charge, et je confirme avoir pris
          connaissance de celles-ci via le lien suivant : «
          <BasicLink
            label="Conditions générales - Akto"
            @link-click="redirectExterne('https://www.akto.fr/conditions-generales')"
          />
        </BasicText>
        »
      </WrapperCheckbox>
      <!-- Attestations FSE -->
      <WrapperCheckbox
        v-if="meta.attestationCadreInterventionFse?.$status !== PropertyStatus.NotPresent"
        v-model="attestationCadreInterventionFseModel"
        :alertLabel="meta.attestationCadreInterventionFse?.$messageErreurDirty!"
        :required="meta.attestationCadreInterventionFse?.$status === PropertyStatus.Required"
        :readonly
        class="col-36"
      >
        <BasicText
          v-if="model?.sousDispositif === 'Fse'"
          style="flex: 1"
        >
          J'atteste avoir pris connaissance du
          <BasicLink
            label="cadre d'intervention du financement FSE+"
            @link-click="redirectExterne('https://www.akto.fr/beneficier-dune-aide-du-fse-en-2025-comment-faire/')"
          />
          et je m'engage à le respecter.
        </BasicText>
        <BasicText
          v-else-if="model?.sousDispositif === 'FTJ'"
          style="flex: 1"
        >
          J'atteste avoir pris connaissance du
          <BasicLink
            label="cadre d'intervention du financement FTJ"
            @link-click="redirectExterne('https://www.akto.fr/cofinancement-du-fonds-de-transition-juste-ftj-aura/')"
          />
          et je m'engage à le respecter.
        </BasicText>
      </WrapperCheckbox>
      <WrapperCheckbox
        v-if="meta.attestationEngagementsFse?.$status !== PropertyStatus.NotPresent"
        v-model="attestationEngagementsFseModel"
        :alertLabel="meta.attestationEngagementsFse?.$messageErreurDirty!"
        :required="meta.attestationEngagementsFse?.$status === PropertyStatus.Required"
        :readonly
        class="col-36"
      >
        <BasicText style="flex: 1">
          J'atteste avoir pris connaissance des
          <BasicLink
            label="engagements relatifs au financement FSE+"
            @link-click="
              redirectExterne('https://www.akto.fr/content/uploads/2025/01/FSE_Memo-engagements-Entreprise-et-OF.pdf')
            "
          />
          et je m'engage à les respecter.
        </BasicText>
      </WrapperCheckbox>
      <WrapperCheckbox
        v-if="meta.attestationInformationParticipantsFse?.$status !== PropertyStatus.NotPresent"
        v-model="attestationInformationParticipantsFseModel"
        :alertLabel="meta.attestationInformationParticipantsFse?.$messageErreurDirty!"
        :required="meta.attestationInformationParticipantsFse?.$status === PropertyStatus.Required"
        :readonly
        class="col-36"
      >
        <BasicText
          v-if="model?.sousDispositif === 'Fse'"
          style="flex: 1"
        >
          Je m'engage à informer les participants du cofinancement par le programme Fonds Social Européen + « emploi,
          inclusion, jeunesse et compétences » et à leur faire remplir les questionnaires en ligne
          <BasicLink
            label="d'entrée"
            @link-click="redirectExterne('https://forms.monday.com/forms/6167b1704255258b1a5f8a4bf53fd043?r=euc1')"
          />
          et de
          <BasicLink
            label="sortie"
            @link-click="redirectExterne('https://forms.monday.com/forms/49ba4512fe566d2b91e0234f6c1b0c2c?r=euc1')"
          />
          de formation.
        </BasicText>
        <BasicText
          v-else-if="model?.sousDispositif === 'FTJ'"
          style="flex: 1"
        >
          Je m'engage à informer les participants du cofinancement FTJ et à leur faire remplir le questionnaire en ligne
          <BasicLink
            label="d'entrée"
            @link-click="redirectExterne('https://forms.monday.com/forms/0036e7b1fc6660dc3b0194776dddc5c3?r=euc1')"
          />
          de formation.
        </BasicText>
      </WrapperCheckbox>
      <WrapperInput
        id="field_unknown"
        v-model="commentaireModel"
        label="Commentaires (infos complémentaires...)"
        :required="meta.commentaire?.$status === PropertyStatus.Required"
        :alertLabel="meta.commentaire?.$messageErreurDirty!"
        class="col-36"
        deletable
        hint="256 caractères maximum"
        :maxlength="256"
        :readonly
      />
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { ModalitePedagogiqueLibelle, NatureContratLibelle } from '@/features/domaine/types/opco/Demande/AF'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { FormContainer, SyntheseSection } from '@/features/interface/demande/shared'
  import {
    dateFormatter,
    formatNumber,
    isDate,
    isNotNullUndefinedOrEmptyString,
    redirectExterne,
  } from '@/features/shared/tools'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'
  import { AF_FRAIS_ANNEXES_ACTIONS } from '@/features/interface/demande/af/steps/frais/useFraisAnnexesActions.ts'
  import { getLabelBoolean } from '@/features/interface/shared/tools/boolean'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { calculSalaire } from '@/features/domaine/regles-akto/shared'
  import { objectIsNotEmpty } from '@/features/interface/shared/tools'

  const store = useDemandeAFStore()
  const { fraisAnnexesModules } = inject(AF_FRAIS_ANNEXES_ACTIONS)!
  const { setupFieldWithKey } = store
  const { model, meta, readonly } = storeToRefs(store)
  const getDateIntitule = (value: any) => (isDate(value) ? dateFormatter(value) : '')
  const idcc = model.value?.employeur?.etablissement?.idcc?.code ?? ''

  const commentaireModel = setupFieldWithKey<string>('commentaire', true)

  const attestationSurHonneurModel = setupFieldWithKey<boolean>('attestationSurHonneur')
  const acceptationCgModel = setupFieldWithKey<boolean>('acceptationCg')

  const attestationCadreInterventionFseModel = setupFieldWithKey<boolean>('attestationCadreInterventionFse')
  const attestationEngagementsFseModel = setupFieldWithKey<boolean>('attestationEngagementsFse')
  const attestationInformationParticipantsFseModel = setupFieldWithKey<boolean>('attestationInformationParticipantsFse')

  const employerDetails = computed(() => ({
    'Entité ADH': model.value?.employeur?.etablissement?.denomination,
    Siret: model.value?.employeur?.etablissement?.siret?.valeur,
    IDCC: idcc,
    Email: model.value?.employeur?.contact?.email,
    'N° et Voie': model.value?.employeur?.etablissement?.adresse?.voie,
    Complément: model.value?.employeur?.etablissement?.adresse?.complement,
    'Code Postal': model.value?.employeur?.etablissement?.adresse?.codePostal,
    Ville: model.value?.employeur?.etablissement?.adresse?.commune,
  }))

  const salariesDetails = computed(() => {
    return (
      model.value?.salaries
        ?.map((salarie) => ({
          Nom: [salarie.prenom, salarie?.nom || salarie?.nomNaissance]
            .filter(isNotNullUndefinedOrEmptyString)
            .join(' '),
          'Date de naissance': getDateIntitule(salarie?.dateNaissance) ?? '',
          'Nature du contrat': salarie?.natureContrat ? NatureContratLibelle[salarie?.natureContrat] : '',
        }))
        ?.filter((s) => objectIsNotEmpty(s)) ?? []
    )
  })

  const formations = computed(() => {
    const modules = model.value?.formation?.modules ?? []
    return modules
      .map(
        (module) =>
          [
            module,
            { $titreSynthese: module.typeModule === 'Interne' ? 'Formation (interne)' : 'Formation (externe)' },
          ] as const,
      )
      .map(([module, infos]) => {
        if (module.typeModule === 'Interne') {
          return [module, infos] as const
        }

        // Spécifique formations externes
        const infosExterne = {
          'Entité OF': module?.etablissement?.denomination ?? '',
          SIRET: module?.etablissement?.siret?.valeur ?? '',
        }
        return [module, { ...infos, ...infosExterne }] as const
      })
      .map(([module, infos]) => {
        // Propriétés communes
        const adresse = [module.lieuFormation?.voie, module.lieuFormation?.codePostal, module.lieuFormation?.commune]
          .filter(isNotNullUndefinedOrEmptyString)
          .join(' ')

        return [
          module,
          {
            ...infos,
            'Adresse du lieu de formation': adresse,
            'Intitulé de formation': module.intitule ?? '',
            'Date de début de formation': getDateIntitule(module.dateDebut),
            'Date de fin de formation': getDateIntitule(module.dateFin),
            'Nombre d’heure de formation': formatNumber(module.duree, { decimal: 2, separateur: true }),
            'Modalité pédagogique': module.modalitePedagogique
              ? ModalitePedagogiqueLibelle[module.modalitePedagogique]
              : '',
          },
        ] as const
      })
      .map(([module, infos]) => {
        if (module.typeModule === 'Interne') {
          return [module, infos] as const
        }

        // Spécifique formations externes
        const infosExterne = {
          "Paiement direct à l'organisme de formation": getLabelBoolean(module.avecSubrogation) ?? '',
        }
        return [module, { ...infos, ...infosExterne }] as const
      })
      .map(([module, infos]) => {
        // Calcule des frais pédagogiques.
        const fraisPédagogiques = module.fraisPedagogiques?.find((frais) => frais.nature === 'Pedagogique')?.montant ?? 0
        const value = `${formatNumber(fraisPédagogiques, { decimal: 2, separateur: true }) ?? ''} €`
        const property = module.typeModule === 'Interne' ? 'Coût pédagogique' : 'Coût formation'
        return [module, { ...infos, [property]: value }] as const
      })
      .map(([module, infos]) => {
        // Calcule type de couts pédagogiques
        const fraisPédagogiques = module.fraisPedagogiques
          ?.filter((frais) => frais.montant)
          ?.filter((frais) => frais?.mode === 'Pedagogique')
          ?.filter((frais) => frais.nature !== 'Pedagogique')
          ?.map((frais) => frais.montant! * (frais.quantite || 1))
          ?.reduce((acc, frais) => acc + frais, 0)

        // Calcule type les frais annexes
        const fraisAnnexesSalariés = fraisAnnexesModules.value
          ?.find((fa) => fa.id === module.id)
          ?.rows?.flatMap((fa) => fa.frais)
          ?.filter((frais) => frais.total)
          ?.reduce((acc, frais) => (acc += (frais.total ?? 0)), 0)

        const totalFrais = (fraisPédagogiques ?? 0) + (fraisAnnexesSalariés ?? 0)
        const value = `${formatNumber(totalFrais, { decimal: 2, separateur: true })} €`
        return [module, { ...infos, 'Autres types de coûts': value }] as const
      })
      .map(([, infos]) => infos) as Record<string, string>[]
  })

  // Détails du chiffrage
  const chiffrageDetails = computed(() => {
    const coutPedagogique = model.value?.formation?.modules
      ? model.value.formation.modules
          .flatMap((module) => module?.fraisPedagogiques ?? [])
          .reduce((acc, frais) => acc + (frais.montant ?? 0), 0)
      : 0

    const dureeFormation = model.value?.formation?.modules?.reduce((sum, mod) => sum + (mod.duree ?? 0), 0) ?? 0
    // const typePublic = model.value?.typePublic

    const remuneration =
      model.value?.salaries?.reduce((sum, sal) => {
        return (
          sum +
          calculSalaire(sal.tauxHoraireBrut ?? 0, sal.pctTauxCharge ?? 0, dureeFormation) * (sal.coefMajoration ?? 1)
        )
      }, 0) ?? 0
    /*
    const fraisAnnexes = model.value?.formation?.modules
      ? model.value.formation.modules
          .flatMap((module) => module?.fraisAnnexesSalarie ?? [])
          .reduce((acc, frais) => acc + (frais.montant ?? 0), 0)
      : 0
    */

    const fraisAnnexes = fraisAnnexesModules.value
      .flatMap((fa) => fa.rows)
      .flatMap((fa) => fa.frais)
      .reduce((acc, frais) => acc + (frais.total ?? 0), 0)

    const total = coutPedagogique + remuneration + fraisAnnexes

    return {
      'Frais de formation': `${formatNumber(coutPedagogique, { decimal: 2, separateur: true })} €`,
      Rémunération: `${formatNumber(remuneration, { decimal: 2, separateur: true })} €`,
      'Frais annexes': `${formatNumber(fraisAnnexes, { decimal: 2, separateur: true })} €`,
      Total: `${formatNumber(total, { decimal: 2, separateur: true })} €`,
    }
  })
</script>

<style scoped lang="less">
  .dark {
    .element {
      &__header,
      &__row {
        > span {
          color: white;
        }
      }
    }
  }

  .synthese__container {
    width: 90%;
    align-self: center;
    margin: @spacing-20 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 20px;

    > div {
      width: calc(45% - 10px);
      border-radius: @border-radius-l;

      @media (max-width: @breakpoint-tablet) {
        width: 100%;
      }
    }

    @container (max-width: @breakpoint-mobile) {
      width: 100%;
    }
  }

  .element {
    &__header {
      display: flex;
      font-weight: bold;
      padding-bottom: @spacing-10;
      border-bottom: 1px solid @secondary-600;
    }

    &__row {
      flex: 1;
      display: flex;
      padding: @spacing-5 0;
      border-bottom: 1px solid #e0e0e0;
    }

    &__header,
    &__row {
      > span {
        flex: 1;
        height: 20px;
        padding: 0 @spacing-5;
        text-align: left;
      }
    }
  }
</style>
